// dev_lp — closing CTA band. Same copy as the original CTA section; CTA is INERT.
import React from "react";
import { useTranslation } from "react-i18next";
import { DEV_AUTH_ITEMS, deadLinkHandler } from "../menuConfig";

const CtaSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="px-4 sm:px-6 mb-20">
      <div className="relative max-w-5xl mx-auto overflow-hidden rounded-[2rem] bg-gradient-to-l from-blue-800 via-blue-700 to-sky-600 px-6 py-14 md:py-16 text-center shadow-2xl shadow-blue-900/30">
        <div className="pointer-events-none absolute -top-16 ltr:-right-16 rtl:-left-16 w-64 h-64 rounded-full bg-white/10 blur-2xl" aria-hidden="true" />
        <h2 className="relative text-2xl md:text-4xl font-extrabold text-white mb-4">
          {t("cta.title")}
        </h2>
        <p className="relative text-base md:text-lg text-blue-50/90 mb-9 max-w-2xl mx-auto">
          {t("cta.subtitle")}
        </p>
        <div className="relative flex flex-col sm:flex-row gap-3.5 justify-center">
          <a
            href={DEV_AUTH_ITEMS[0].route}
            data-devlp-route={DEV_AUTH_ITEMS[0].route}
            onClick={deadLinkHandler}
            className="px-8 py-4 rounded-full bg-white text-blue-700 text-base font-bold shadow-lg hover:-translate-y-0.5 transition-all focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-blue-700"
          >
            {t("cta.register")}
          </a>
          <a
            href={DEV_AUTH_ITEMS[1].route}
            data-devlp-route={DEV_AUTH_ITEMS[1].route}
            onClick={deadLinkHandler}
            className="px-8 py-4 rounded-full text-white text-base font-bold border-2 border-white/70 hover:bg-white/10 hover:-translate-y-0.5 transition-all focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-blue-700"
          >
            {t("cta.login")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
